import * as  BaseSiteActions from './baseSites.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { BaseSite } from '@kion/data-models';

export const BASESITES_FEATURE_KEY = 'baseSite';

export interface BaseSitesState extends EntityState<BaseSite> {
  error?: any;
  lastCreatedId: string|null;

  isSearching: boolean;
  searchResultIds: string[];
}

export const adapter: EntityAdapter<BaseSite> = createEntityAdapter<BaseSite>();

export interface BaseSitesPartialState {
  readonly [BASESITES_FEATURE_KEY]: BaseSitesState;
}

export const initialState: BaseSitesState = adapter.getInitialState({
  lastCreatedId: null,
  isSearching: false,
  searchResultIds: [],
  searchQuery: {},
  pagination: {
    page: 1,
    perPage: 10,
    totalPages: 0,
    count: 0,
    total: 0
  }
});

const BaseSitesReducer = createReducer(
  initialState,
  on(
    BaseSiteActions.loadAllSuccess,
    (state, { baseSites  }) => adapter.upsertMany(baseSites , { ...state })
  ),
  on(
    BaseSiteActions.setActiveSuccess,
    (state, { baseSite  }) => {
      const all = state.entities;
      const allSites: BaseSite[] = [];
      // tslint:disable-next-line:forin
      for (const key in all) {
        allSites.push(all[key]);
      }
      return adapter.upsertMany(
        allSites.map(
          site => {
            if (site.id === baseSite.id) {
              return {
                ...site,
                isActive: true
              }
            }
            return {
              ...site,
              isActive: false
            }
          }
        )
        ,
        { ...state })
    }
  )
);

export function reducer(
  state: BaseSitesState | undefined,
  action: Action
) {
  return BaseSitesReducer(state, action);
}
